import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowCircleLeft, FaCheck, FaEye, FaSignInAlt, FaTimesCircle } from 'react-icons/fa';

const dividerClass = 'border-b border-base-300 py-2';
const inputClass = 'input input-bordered input-sm w-full';
const selectClass = 'select select-bordered select-sm w-full';
const textareaClass = 'textarea textarea-bordered textarea-sm w-full';

const AddEditAppointmentMockup: React.FC = () => {
  return (
    <div className="p-4 md:p-6 bg-base-100 text-base-content min-h-screen">
      <Link to="/scheduling/appointments" className="btn btn-warning btn-sm mb-4">
        <FaArrowCircleLeft className="mr-2" />
        Back to Appointments
      </Link>

      <div className="card bg-base-100 border border-warning shadow">
        <div className="card-body p-4 md:p-5">
          <div className="mb-4">
            <h2 className="text-xl font-semibold flex items-center gap-2">
              <FaSignInAlt /> Add / Edit Appointment
            </h2>
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">
            <div className="xl:col-span-9 space-y-2">

              <div className={dividerClass} />

              <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-6 gap-2">
                <input className={inputClass} placeholder="First Name" />
                <input className={inputClass} placeholder="Last Name" />
                <input className={inputClass} placeholder="Title" />
                <input className={inputClass} placeholder="DOB" />
                <input className={inputClass} placeholder="Age" />
                <select className={selectClass} defaultValue="Sex">
                  <option>Sex</option>
                  <option>Male</option>
                  <option>Female</option>
                </select>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="grid grid-cols-1 gap-2">
                  <input className={inputClass} placeholder="Patient No" />
                  <div className="text-sm"><strong>Hospital U.P</strong> <span className="ml-3">$54167</span></div>
                  <div className="text-sm"><strong>Provider</strong> <span className="ml-3">Paul Verrills</span></div>
                </div>
                <textarea className={textareaClass} rows={4} placeholder="Details" />
              </div>

              

              <div className={dividerClass} />

              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2">
                <div className="bg-base-200 border border-base-300 p-2 h-[200px] space-y-1 overflow-hidden">
                  <input className={inputClass} placeholder="Medicare No" />
                  <input className={inputClass} placeholder="M/Care Expire" />
                  <input className={inputClass} placeholder="Pension No" />
                  <input className={inputClass} placeholder="DVA" />
                  <select className={selectClass} defaultValue="Charge type">
                    <option>Charge type</option>
                    <option>8-Pension</option>
                  </select>
                </div>

                <div className="bg-base-200 border border-base-300 p-2 h-[200px] space-y-1 overflow-hidden">
                  <input className={inputClass} placeholder="Health Function" />
                  <input className={inputClass} placeholder="Member No" />
                  <input className={inputClass} placeholder="Fund Excess" />
                  <label className="label cursor-pointer justify-start gap-2 py-1">
                    <input type="checkbox" className="checkbox checkbox-sm" />
                    <span className="label-text">Has co-payment</span>
                  </label>
                </div>

                <div className="bg-base-200 border border-base-300 p-2 h-[200px] space-y-1 overflow-hidden">
                  <input className={inputClass} placeholder="Home Phone" />
                  <input className={inputClass} placeholder="Work Phone" />
                  <input className={inputClass} placeholder="Mobile No" />
                  <button type="button" className="btn btn-warning btn-sm mt-3">Send SMS</button>
                </div>

                <div className="bg-base-200 border border-base-300 p-2 h-[200px] space-y-1 overflow-hidden">
                  <textarea className={textareaClass} rows={3} placeholder="Address" />
                  <input className={inputClass} placeholder="Post Code" />
                  <input className={inputClass} placeholder="State" />
                  <input type="email" className={inputClass} placeholder="Email" />
                </div>
              </div>

              <div className={dividerClass} />

              <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                <input className={inputClass} placeholder="Referring Doctor" />
                <input className={inputClass} placeholder="Referral Date" />
                <select className={selectClass} defaultValue="Select Referral Period">
                  <option>Select Referral Period</option>
                  <option>8-Month</option>
                </select>
              </div>

              <div className={dividerClass} />

              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
                <input className={inputClass} placeholder="Consultation/Process" />
                <input className={inputClass} placeholder="Referral Source" />
                <select className={selectClass} defaultValue="Location of operation">
                  <option>Location of operation</option>
                  <option>left-eye</option>
                  <option>right-eye</option>
                </select>
                <select className={selectClass} defaultValue="Location">
                  <option>Location</option>
                  <option>MPG</option>
                </select>
                <select className={selectClass} defaultValue="Specific Resource">
                  <option>Specific Resource</option>
                </select>
                <select className={selectClass} defaultValue="Anaesthesia">
                  <option>Anaesthesia</option>
                </select>
              </div>

              <div className={dividerClass} />

              <textarea className={textareaClass} rows={4} placeholder="Note and Operation Details" />

              <div className={dividerClass} />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label className="label py-1"><span className="label-text font-medium">Other Appointment</span></label>
                  <div className="h-[60px] overflow-y-auto border-2 border-base-300 p-1 text-sm space-y-1">
                    <div className="flex flex-wrap gap-2"><span>15-08-2018 13:00 ST</span><span>NW</span><span>MPG</span></div>
                    <div className="flex flex-wrap gap-2"><span>15-08-2018 13:00 ST</span><span>NW</span><span>MPG</span></div>
                  </div>
                </div>
                <div>
                  <label className="label py-1"><span className="label-text font-medium">Recurring Appointment</span></label>
                  <label className="label cursor-pointer justify-start gap-2 py-1">
                    <input type="checkbox" className="checkbox checkbox-sm" />
                    <span className="label-text">Print Consultation/Procedure Info</span>
                  </label>
                </div>
              </div>
            </div>

            <div className="xl:col-span-3">
              <div className="border border-base-300 p-3 h-full bg-base-100">
                <div className="mb-3">
                  <div className="flex items-start">
                    <h1 className="text-6xl leading-none w-1/5">8</h1>
                    <h4 className="w-4/5 mt-2 text-lg">
                      <span>Wednesday</span><br />
                      <span>August 2018</span>
                    </h4>
                  </div>
                </div>

                <div className="space-y-1">
                  <input className={inputClass} placeholder="Date" />
                  <input className={inputClass} placeholder="Start Timing" />
                  <select className={selectClass} defaultValue="Duration">
                    <option>Duration</option>
                    <option>45 min</option>
                  </select>
                  <input className={inputClass} placeholder="Arrive atleast before" />

                  <label className="label cursor-pointer justify-start gap-2 py-0">
                    <input type="checkbox" className="checkbox checkbox-sm" />
                    <span className="label-text">Confirmed</span>
                  </label>
                  <label className="label cursor-pointer justify-start gap-2 py-0">
                    <input type="checkbox" className="checkbox checkbox-sm" />
                    <span className="label-text">IR Scanned</span>
                  </label>

                  <input className={inputClass} placeholder="Quoted Price" />
                  <input className={inputClass} placeholder="Preffered Procedure" />
                  <input className={inputClass} placeholder="Went for path" />
                  <input className={inputClass} placeholder="Special Request" />
                  <input className={inputClass} placeholder="Employee Name" />

                  <label className="label cursor-pointer justify-start gap-2 py-0">
                    <input type="checkbox" className="checkbox checkbox-sm" />
                    <span className="label-text">Print Appointment Details Slip</span>
                  </label>

                  <select className={selectClass} defaultValue="App Status">
                    <option>App Status</option>
                  </select>

                  <label className="label cursor-pointer justify-start gap-2 py-0">
                    <input type="checkbox" className="checkbox checkbox-sm" />
                    <span className="label-text">Wait List</span>
                  </label>

                  <p className="text-xs mt-2">Appointment made on 06/04.2018 by Missed Appointment</p>

                  <div className="flex flex-wrap gap-1 pt-1">
                    <button className="btn btn-warning btn-sm"><FaEye className="mr-1" />View</button>
                    <button className="btn btn-warning btn-sm"><FaCheck className="mr-1" />OK</button>
                    <button className="btn btn-warning btn-sm"><FaTimesCircle className="mr-1" />Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditAppointmentMockup;
